export default __webpack_public_path__ + "static/media/logoDark.9fe949ba.svg";